import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/internal/report';

export class ReportServiceInternal implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async createCadDrawingReport({
    path,
    body,
  }: types.CreateCadDrawingReportParameters): Promise<types.CreateReportResponse> {
    const { data } = await this.axios.post<types.CreateReportResponse>(
      `/report/${path.projectId}/cad-drawing`,
      body,
    );
    return data;
  }
}
